import React from "react";

function IconWeb({width}) {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width={width}
      height="22.028"
      viewBox="0 0 6.35 5.828"
    >
      <circle
        cx="3.186"
        cy="2.914"
        r="2.646"
        fill="none"
        stroke="#313131"
      ></circle>
      <path
        fill="none"
        stroke="#313131"
        d="M.54 3.046h5.292M3.186.268a4.048 4.048 0 011.058 2.646A4.048 4.048 0 013.186 5.56a4.048 4.048 0 01-1.058-2.646A4.048 4.048 0 013.186.268z"
      ></path>
    </svg>
  );
}

export default IconWeb;
